var render = function render(){
  var _vm$summary, _vm$summary$entireAmo, _vm$summary$entireAmo2, _vm$summary2, _vm$summary2$overallP, _vm$summary2$overallP2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "row--xs"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticClass: "pa-5 h-100",
    attrs: {
      "rounded": "",
      "color": "grey lighten-5"
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "space-between",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "txt txt--xs"
  }, [_vm._v("재고현황")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "txt txt--lg txt--dark font-weight-bold d-flex align-center"
  }, [_vm._v(_vm._s(((_vm$summary = _vm.summary) === null || _vm$summary === void 0 ? void 0 : (_vm$summary$entireAmo = _vm$summary.entireAmount) === null || _vm$summary$entireAmo === void 0 ? void 0 : (_vm$summary$entireAmo2 = _vm$summary$entireAmo.format) === null || _vm$summary$entireAmo2 === void 0 ? void 0 : _vm$summary$entireAmo2.call(_vm$summary$entireAmo)) || 0)), _c('span', {
    staticClass: "txt--xs ml-2px"
  }, [_vm._v("개")])])])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticClass: "pa-5 h-100",
    attrs: {
      "rounded": "",
      "color": "grey lighten-5"
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "space-between",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "txt txt--xs"
  }, [_vm._v("총액")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "txt txt--lg primary--text font-weight-bold d-flex align-center"
  }, [_vm._v(_vm._s(((_vm$summary2 = _vm.summary) === null || _vm$summary2 === void 0 ? void 0 : (_vm$summary2$overallP = _vm$summary2.overallPrice) === null || _vm$summary2$overallP === void 0 ? void 0 : (_vm$summary2$overallP2 = _vm$summary2$overallP.format) === null || _vm$summary2$overallP2 === void 0 ? void 0 : _vm$summary2$overallP2.call(_vm$summary2$overallP)) || 0)), _c('span', {
    staticClass: "txt--xs ml-2px"
  }, [_vm._v("원")])])])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }